// A figure's title, NYT style: a hairline above, the app's sans.
export const SectionTitle = ({ children }: { children: string }) => (
  <div className='mb-3.5 border-t border-foreground pt-2.5'>
    <h3 className='text-[1.0625rem] font-bold text-foreground'>{children}</h3>
  </div>
);
